import { apiClient } from '@/services/ApiClient.js'

export class TarfinProProductPriceService {
  static getProducts() {
    return apiClient
      .get('tarfin-pro-product-prices')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static updatePrices(params) {
    return apiClient
      .patch('tarfin-pro-product-prices/update-prices', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static createPrice(params) {
    return apiClient
      .post('tarfin-pro-product-prices', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getMarketInfo() {
    return apiClient
      .get('tarfin-pro-product-prices/get-market-info')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static changeMarketStatus(params) {
    return apiClient
      .patch('tarfin-pro-product-prices/update-market-status', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static deletePrice(id) {
    return apiClient
      .delete('tarfin-pro-product-prices/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
